class AuthService {
  constructor() {
    this.token = window.localStorage.getItem("asteria_token");
    this.user = JSON.parse(window.localStorage.getItem("asteria_user"));
    this.userTitle = window.localStorage.getItem("asteria_user");
  }

  check() {
    return !!this.token;
  }

  setUser(user, silent = false) {
    window.localStorage.removeItem("asteria_user");
    window.localStorage.setItem("asteria_user", JSON.stringify(user));
    this.user = user;

    if (!silent) location.reload();
  }

  login(token, user) {
    window.localStorage.setItem("asteria_token", token);
    window.localStorage.setItem("asteria_user", JSON.stringify(user));
    this.token = token;
    this.user = user;
    location.reload();
  }

  loginAdmin(token, user) {
    window.localStorage.removeItem("asteria_user");
    window.localStorage.removeItem("asteria_token");

    window.localStorage.setItem("asteria_token", token);
    window.localStorage.setItem("asteria_user", JSON.stringify(user));

    this.token = token;
    this.user = user;
    window.location.href = "/";
  }

  logout() {
    window.localStorage.removeItem("asteria_token");
    window.localStorage.removeItem("asteria_user");
    location.reload();
  }

  timerLogout(logoutMessage) {
    window.localStorage.setItem("sessionExpiry", logoutMessage);
    // window.localStorage.removeItem("asteria_token");
    // window.localStorage.removeItem("asteria_user");

    // window.location.href = "/";
  }
}

export default new AuthService();
